var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6087 31.432V15.757C50.6087 11.1366 50.6087 8.82636 49.6414 7.06158C48.7905 5.50925 47.4328 4.24716 45.7629 3.4562C43.8644 2.55701 41.3792 2.55701 36.4087 2.55701H17.4754C12.5049 2.55701 10.0197 2.55701 8.12123 3.4562C6.45129 4.24716 5.09358 5.50925 4.24271 7.06158C3.27539 8.82636 3.27539 11.1366 3.27539 15.757V44.357C3.27539 48.9774 3.27539 51.2877 4.24271 53.0524C5.09358 54.6048 6.45129 55.8668 8.12123 56.6578C10.0197 57.557 12.5048 57.557 17.475 57.557H28.4212M32.8587 27.307H15.1087M21.0254 38.307H15.1087M38.7754 16.307H15.1087M35.8171 49.307L44.6921 57.557M44.6921 57.557L53.5671 49.307M44.6921 57.557V41.057",
    stroke: "#0065B3",
    strokeWidth: 4.59988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDownload);
export default __webpack_public_path__ + "static/media/blueDownload.a06121e3eb152a021c09b6ee5f48a1b8.svg";
export { ForwardRef as ReactComponent };